'use client';

import { Component, ErrorInfo, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

interface ErrorBoundaryProps {
  children?: ReactNode;
  errorMessage?: string;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    const { errorMessage } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return (
        <Box sx={{ p: 4 }}>
          <Typography variant="h5" color="error">
            {errorMessage || 'Something went wrong.'}
          </Typography>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
